export default __webpack_public_path__ + "static/media/loading.e28aea36.gif";